export default "/assets/images/la-strong-bg.jpg?6dc43304252edb54e0e9d03b8952c08a";